import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import { useState } from 'react';
import CourseDetails from './CourseDetails';
import PersonalDetails from './PersonalDetails';
import Summary from './Summary';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Typography } from '@mui/material';

const steps = [{ label: 'Personal details' }, { label: 'License & Employment' }, { label: 'Summary' }];

const ApplyForm = () => {
  const [data, setData] = useState({
    step: 0,
    firstname: '',
    middlename: '',
    lastname: '',
    email: '',
    phone: '',
    courses: [],
    level: '',
    isErrorFirstName: true,
    isErrorLastName: true,
    errorMessageFirstName: '',
    errorMessageLastName: '',
    driverlicenceno: '',
    driverlicencetype: 'Full',
    driverlicenceversion: '',
    occupation: '',
    employer: '',
    residentialType: 'Mortgage',
    residencyStatus: 'Yes',
    gender: 'Male',
    dateOfBirth: null,
    licenceExpiry: null,
  });

  const [formSubmitted, setFormSubmitted] = useState(false);

  const nextStep = () => {
    setData(prevState => ({ ...prevState, step: prevState.step + 1 }));
  };

  const prevStep = () => {
    setData(prevState => ({ ...prevState, step: prevState.step - 1 }));
  };

  const handleChange = input => e => {
    setData(prevState => ({ ...prevState, [input]: e.target.value }));
    if (input === 'firstname') {
      if (data.firstname.length >= 1) {
        setData(prevState => ({ ...prevState, isErrorFirstName: false }));
      }
    } else if (input === 'lastname') {
      if (data.lastname.length >= 1) {
        setData(prevState => ({ ...prevState, isErrorLastName: false }));
      }
    }
  };

  const setDefaultValues = (input) => {
    if (input === 'licenceExpiry') {
      setData(prevState => ({ ...prevState, [input]: '1970-01-01' }));
    }
  }

  const validateFirstName = () => {
    if (data.firstname.length < 2) {
      setData(prevState => ({
        ...prevState,
        isErrorFirstName: true,
        errorMessageFirstName: 'Type your first name (at least 2 characters)',
      }));
      return false;
    }
    return true;
  };

  const validateLastName = () => {
    if (data.lastname.length < 2) {
      setData(prevState => ({
        ...prevState,
        isErrorLastName: true,
        errorMessageLastName: 'Type your last name (at least 2 characters)',
      }));
      return false;
    }
    return true;
  };

  const vaidateEmail = () => {
    if (data.email.length < 5) {
      setData(prevState => ({
        ...prevState,
        isErrorLastName: true,
        errorMessageLastName: 'Please provide a valid email address',
      }));
      return false;
    }
    return true;
  };

  const validateMobile = () => {
    if (data.phone.length < 9) {
      setData(prevState => ({
        ...prevState,
        isErrorLastName: true,
        errorMessageLastName: 'Please provide a valid phone number',
      }));
      return false;
    }
    return true;
  };

  const submitData = (e, d) => {
    e.preventDefault();
    setFormSubmitted(true);
    var date = new Date()
    let ExternalId = date.getTime() / 1000;
    const requestData = {
      ExternalId: ExternalId,
      Eligibility: true,
      JointLoan: false,
      MainApplicant: {
        FirstName: d.firstname,
        LastName: d.lastname,
        MobilePhone: d.phone,
        EmailAddress: d.email,
        DateOfBirth: d.dateOfBirth,
        Address: d.occupation,
        DriversLicense: {
          Type: d.driverlicencetype,
          Number: d.driverlicenceno,
          Version: d.driverlicenceversion,
          Expiry: d.licenceExpiry,
          Comments: '',
        },
      },
      Vehicle: { Price: 0, Model: '', Make: '', Year: '', Colour: '', VIN: '', Registration: '', JustCarId: '' },
      Dealer: { Dealership: '', DealerContact: '', Phone: '', Email: '', JustCarId: '' },
    };

    const apiUrl = process.env.REACT_APP_FUNCTION_API_URL;
    if (!apiUrl) {
      console.error('API URL is not defined in the environment.');
      return;
    }

    fetch(apiUrl, {
      method: 'POST',
      headers: {
        Authorization: `Basic ZmluYW5jZWFkbWluOjQ/bjEwMFF0`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        console.log('Success:', data);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  };

  const renderSteps = () => {
    return steps.map(({ label }, index) => (
      <Step
        key={index}
        sx={{
          '& .MuiStepLabel-root .Mui-active': { color: '#b4855a' },
          '& .MuiStepLabel-root .Mui-completed': {
            color: '#b4855a', // circle color (COMPLETED)
          },
        }}
      >
        <StepLabel>{label}</StepLabel>
      </Step>
    ));
  };

  const renderSubmitFormMessage = () => {
    setTimeout(() => {
      setFormSubmitted(false);
      setData({
        step: 0,
        firstname: '',
        middlename: '',
        lastname: '',
        email: '',
        phone: '',
        courses: [],
        level: '',
        isErrorFirstName: true,
        isErrorLastName: true,
        errorMessageFirstName: '',
        errorMessageLastName: '',
        driverlicenceno: '',
        driverlicencetype: 'Full',
        driverlicenceversion: '',
        occupation: '',
        employer: '',
        residentialType: 'Mortgage',
        residencyStatus: 'Yes',
        gender: 'Male',
        dateOfBirth: null,
        licenceExpiry: null
      });
    }, 3000);

    return (
      <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
        <CheckCircleIcon sx={{ color: "green", fontSize: "10rem", paddingBottom: "20px" }}/>
        <Typography variant="h5" fontWeight="bold">Thank you for your application!</Typography>
        <Typography variant="h6">We will be in touch shortly.</Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ width: '100%' }}>
      {formSubmitted ? (
        renderSubmitFormMessage()
      ) : (
        <>
          <Stepper activeStep={data.step} alternativeLabel className="stepper">
            {renderSteps()}
          </Stepper>

          {data.step === 0 && (
            <PersonalDetails
              nextStep={nextStep}
              handleChange={handleChange}
              firstname={data.firstname}
              lastname={data.lastname}
              email={data.email}
              phone={data.phone}
              validateFirstName={validateFirstName}
              validateLastName={validateLastName}
              isErrorFirstName={data.isErrorFirstName}
              isErrorLastName={data.isErrorLastName}
              errorMessageFirstName={data.errorMessageFirstName}
              errorMessageLastName={data.errorMessageLastName}
              residentialType={data.residentialType}
              residencyStatus={data.residencyStatus}
              gender={data.gender}
              dateOfBirth={data.dateOfBirth}
            />
          )}

          {data.step === 1 && (
            <CourseDetails
              nextStep={nextStep}
              prevStep={prevStep}
              handleChange={handleChange}
              driverlicenceno={data.driverlicenceno}
              driverlicencetype={data.driverlicencetype}
              driverlicenceversion={data.driverlicenceversion}
              occupation={data.occupation}
              employer={data.employer}
              residencyStatus={data.residencyStatus}
              residentialType={data.residentialType}
              gender={data.gender}
              licenceExpiry={data.licenceExpiry}
              setDefaultValues={setDefaultValues}
            />
          )}

          {data.step === 2 && (
            <Summary
              nextStep={nextStep}
              prevStep={prevStep}
              firstname={data.firstname}
              middlename={data.middlename}
              lastname={data.lastname}
              email={data.email}
              phone={data.phone}
              driverlicenceno={data.driverlicenceno}
              driverlicencetype={data.driverlicencetype}
              driverlicenceversion={data.driverlicenceversion}
              occupation={data.occupation}
              employer={data.employer}
              residencyStatus={data.residencyStatus}
              residentialType={data.residentialType}
              gender={data.gender}
              dateOfBirth={data.dateOfBirth}
              licenceExpiry={data.licenceExpiry}
              submitData={submitData}
            />
          )}
        </>
      )}
    </Box>
  );
};

export default ApplyForm;

/*
ar
ba 
test@test.com
883691263916376

*/
